import GSAP from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

GSAP.registerPlugin(ScrollTrigger);

export default class PinLayer {
  constructor({ element }) {
    this.element = element;

    this.scrollTrigger = null;
    this._animate();
  }

  _animate() {
    // Create a GSAP tween that moves the element up while scrolling
    this.tween = GSAP.to(this.element, {
      scrollTrigger: {
        trigger: this.element,
        start: 'top top',
        end: 'bottom top',
        pin: true,
        pinSpacing: false,
        markers: false,
      },
    });
  }
  destroy() {
    this.tween?.kill();
    this.tween = null;
  }
}
